module.exports = __webpack_public_path__ + "img/store-slash.18971730.svg";